import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';
import { Checkbox } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';
import { useMoneyMask } from '@redlink/core';

export const OrderRowItem = memo(
  ({ title, onChange, value, textStyle, price, priceTextStyle, count }) => {
    const { styles } = useStyle();
    const { dictionary } = useLocale();
    const { getValue } = useMoneyMask();
    const priceText = `${getValue(price)} ${dictionary.moneyPostfix}`;
    return (
      <View style={styles.itemContainer}>
        <Checkbox
          {...{ title, value, textStyle, onChange }}
          style={styles.checkboxContainer}
        >
          <View style={styles.titlesContainer}>
            {count && (
              <>
                <Space />
                <Text style={styles.countText}>x</Text>
                <Space size={2} />
                <Text style={styles.countText}>{count}</Text>
              </>
            )}
          </View>
        </Checkbox>
        <Text style={[styles.totalPriceText, priceTextStyle]}>{priceText}</Text>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  itemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  checkboxContainer: {
    flex: 1,
  },
  totalPriceTitleText: {
    fontSize: 16,
    color: colors.gray23,
  },
  totalPriceText: {
    color: colors.gray23,
    fontSize: 16,
  },
  titleText: {
    fontSize: 14,
    color: colors.gray23,
  },
  countText: {
    fontWeight: '600',
    fontSize: 16,
    color: colors.green1
  },
  titlesContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingStart: 8,
  },
}));
